import RequestedFeature from '@carvana/merch-contracts/RequestedFeature';

export default function resolveConditionalTilesFeature(
  dealershipId: string | null | undefined,
  suppressConditionalTiles: boolean
): RequestedFeature | undefined {
  if (dealershipId) {
    return RequestedFeature.DealershipConditionalTiles;
  }

  return suppressConditionalTiles
    ? undefined
    : RequestedFeature.ConditionalTiles;
}
